import { useState, useEffect, useMemo } from 'react';
import React from 'react';
type FetchFunc<DataType> = (...args: any[]) => Promise<DataType>;

export const useDataApi = <DataType,>(
  func: FetchFunc<DataType>,
  initialData: DataType,
  ...args: any[]
): [
  { data: DataType; isLoading: boolean; isError: boolean },
  React.Dispatch<React.SetStateAction<DataType>>,
] => {
  const [data, setData] = useState<DataType>(initialData);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);

      try {
        const data = await func(...args);
        setData(data);
      } catch (error) {
        console.error(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [...args, func]); // eslint-disable-line react-hooks/exhaustive-deps
  const response = useMemo(
    () => ({
      data,
      isLoading,
      isError,
    }),
    [data, isError, isLoading],
  );
  return [response, setData];
};
